// src/util/getCompatiblePropValue.ts
var getCompatiblePropValue = function getCompatiblePropValue(newValue, oldValue, defaultOldValue) {
  if (oldValue !== void 0) {
    return oldValue;
  }
  if (newValue !== void 0) {
    return newValue;
  }
  return defaultOldValue;
};
export { getCompatiblePropValue };